import React, { useState, useEffect } from 'react';

function UpdatePasswordPage({ onBack }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleUpdate = () => {
    // Handle update password action
    if (newPassword !== confirmPassword) {
      alert('New password and confirm password do not match');
      return;
    }
    if (newPassword.length < 6) {
      alert('Password must be at least 6 characters long');
      return;
    }
    console.log('Update Password:', { oldPassword, newPassword });
    // You can add API call here
  };

  return (
    <div className="update-password-page">
      {/* Top Navigation Bar */}
      <div className="update-password-top-bar">
        <div className="update-password-back-btn" onClick={onBack}>
          <i className="bi bi-chevron-left"></i>
        </div>
        <div className="update-password-title-text">Update Password</div>
        <div className="update-password-spacer"></div>
      </div>

      {/* Main Content */}
      <div className="update-password-content">
        {/* Old Password Field */}
        <div className="update-password-field-group">
          <label className="update-password-label">Old Password</label>
          <input
            type="password"
            className="update-password-input"
            placeholder="Old Password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
          />
        </div>

        {/* New Password Field */}
        <div className="update-password-field-group">
          <label className="update-password-label">New Password</label>
          <input
            type="password"
            className="update-password-input"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        {/* Confirm New Password Field */}
        <div className="update-password-field-group">
          <label className="update-password-label">Confirm New Password</label>
          <input
            type="password"
            className="update-password-input"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        {/* Update Button */}
        <button className="update-password-btn" onClick={handleUpdate}>
          Update
        </button>
      </div>
    </div>
  );
}

export default UpdatePasswordPage;

